import { useContext } from "react";
import { CollectionContext } from "./CollectionProvider";

export default function useCollection() {
    return useContext(CollectionContext);
}